import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "scale-wrapper" }
const _hoisted_2 = { class: "vertical-scale" }

import { computed } from 'vue';
import { tickCount, tickUnits, getDisabledClasses } from "@/guiide/ts/wants/wantsUtilities";
import { roundUpToNearest } from "../../ts/utilities";

type Label = { value: number, text: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'IncomeScale',
  props: {
    maxValue: Number,
    step: { type: Number, default: 10000 },
    disabled: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props;

const labels = computed<Array<Label>>(() => {
    const unit = roundUpToNearest(props.maxValue / tickCount, tickUnits);
    const ticks = props.maxValue / unit;
    return Array.from({ length: ticks + 1 }, (_, i) => (i * unit)).map(v => { return { value: v, text: (v / 1000).toString() } as Label });
});

const getPositionStyle = (labelValue: number) => {
    const positionPercentage = (labelValue / props.maxValue) * 100;
    const baseTweak = 2;
    const positionTweak = (positionPercentage / 100) * 5;
    const tweak = baseTweak + positionTweak;
    const bottom = positionPercentage - tweak;
    return { bottom: `${bottom}%` };
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["scale-label content-label", _unref(getDisabledClasses)(__props.disabled)])
      }, "£'000", 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(labels.value, (label) => {
        return (_openBlock(), _createElementBlock("div", {
          key: label.value,
          style: _normalizeStyle(getPositionStyle(label.value)),
          class: _normalizeClass(["scale-label", _unref(getDisabledClasses)(__props.disabled)])
        }, _toDisplayString(label.text), 7))
      }), 128))
    ])
  ]))
}
}

})